import * as Types from "../../../apollo/graphql.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {};
export type CollectionFieldsFragment = {
  __typename: "Collection";
  id: string;
  name: string;
  type: Types.CollectionContractType;
  collectionType: Types._CollectionType;
  chainId: number;
  contractId: string;
  status: Types.CollectionStatus;
  createdAt: string;
  baseUri: string | null;
  standard: Types.NftContractStandard | null;
  usingOpenseaBlocklist: boolean | null;
  seriesDetails: {
    __typename: "SeriesDetails";
    coverImage: number;
    mintPreviewImages: Array<number>;
    mintPreviewImageUrls: Array<string> | null;
    mintPreviewMediaUrls: Array<string> | null;
    logoUrl: string | null;
  } | null;
  generativeDetails: {
    __typename: "GenerativeDetails";
    logoUrl: string | null;
    generativeCodeUri: string;
    allowedHashes: Array<string> | null;
    mirroredBaseUri: string | null;
    captureSettings: {
      __typename: "GenerativeCaptureSettings";
      trigger: Types.CapturePreviewTriggerType;
      delay: number | null;
      selector: string | null;
      viewPort: {
        __typename: "GenerativeCaptureViewPortSettings";
        height: number;
        width: number;
      } | null;
    };
  } | null;
  seriesImages: {
    __typename: "SeriesImages";
    urls: Array<string>;
    coverImageUrl: string;
  } | null;
  editions: Array<{
    __typename: "EditionToken";
    name: string;
    description: string;
    image: string;
    size: number;
    onChainImage: string;
    nonTransferable: boolean | null;
    attributes: Array<{
      __typename: "TokenMetadataAttribute";
      trait_type: string;
      value: string;
    }> | null;
  }> | null;
  tokens: Array<{
    __typename: "GeneralToken";
    animation_url: string | null;
    image: string;
    name: string;
    description: string;
    id: string;
    nonTransferable: boolean | null;
    royalty: {
      __typename: "V1Royalty";
      royaltyPercentageString: string | null;
      royaltyRecipient: string | null;
    } | null;
  }> | null;
  importData: {
    __typename: "ImportData";
    description: string | null;
    media: string | null;
    standard: string | null;
    royalty: {
      __typename: "V1Royalty";
      royaltyRecipient: string | null;
      royaltyPercentageString: string | null;
    } | null;
  } | null;
  contract: { __typename: "Contract2"; address: string | null } | null;
};

export type MintVectorFieldsFragment = {
  __typename: "MintVector";
  id: string | null;
  collectionId: string | null;
  start: string;
  end: string | null;
  price: string;
  currency: string;
  maxPerTxn: number;
  maxPerUser: number;
  maxPerVector: number;
  gateId: string | null;
  paymentRecipient: string;
};

export type ImportTokenFieldsFragment = {
  __typename: "ImportedToken";
  id: string;
  type: Types.ImportedTokenType | null;
  name: string;
  symbol: string | null;
  address: string;
  tokenId: string | null;
  chainId: number;
  contractUri: string | null;
  importData: {
    __typename: "ImportData";
    description: string | null;
    media: string | null;
    standard: string | null;
  } | null;
};

export type MintVectorByCollectionFieldsFragment = {
  __typename: "MintVector";
  id: string | null;
  collectionId: string | null;
  start: string;
  end: string | null;
  paused: boolean | null;
  currency: string;
  maxPerTxn: number;
  maxPerUser: number;
  maxPerVector: number;
  price: string;
  priceType: Types.PriceType | null;
  stats: {
    __typename: "MintVectorStats";
    total: number;
    sold: number;
    status: Types.MintVectorStatus;
  } | null;
};

export type AuctionByCollectionFieldsFragment = {
  __typename: "Auction";
  id: string | null;
  collectionId: string;
  createdAt: string;
  start: string;
  end: string;
  paused: boolean | null;
  stats: {
    __typename: "AuctionStats";
    currentBid: number;
    highestBidder: string;
    status: Types.AuctionStatus;
    totalBids: number;
  } | null;
};

export type GetBlockchainEntitiesByUserQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetBlockchainEntitiesByUserQuery = {
  getBlockchainEntitiesByUser: {
    __typename: "BlockchainEntities";
    collections: Array<{
      __typename: "Collection";
      openSeaCollectionUrl: string | null;
      id: string;
      name: string;
      type: Types.CollectionContractType;
      collectionType: Types._CollectionType;
      chainId: number;
      contractId: string;
      status: Types.CollectionStatus;
      createdAt: string;
      baseUri: string | null;
      standard: Types.NftContractStandard | null;
      usingOpenseaBlocklist: boolean | null;
      mintVectors: Array<{
        __typename: "MintVector";
        id: string | null;
        collectionId: string | null;
        start: string;
        end: string | null;
        paused: boolean | null;
        currency: string;
        maxPerTxn: number;
        maxPerUser: number;
        maxPerVector: number;
        price: string;
        priceType: Types.PriceType | null;
        stats: {
          __typename: "MintVectorStats";
          total: number;
          sold: number;
          status: Types.MintVectorStatus;
        } | null;
      }>;
      auctions: Array<{
        __typename: "Auction";
        id: string | null;
        collectionId: string;
        createdAt: string;
        start: string;
        end: string;
        paused: boolean | null;
        stats: {
          __typename: "AuctionStats";
          currentBid: number;
          highestBidder: string;
          status: Types.AuctionStatus;
          totalBids: number;
        } | null;
      }>;
      seriesDetails: {
        __typename: "SeriesDetails";
        coverImage: number;
        mintPreviewImages: Array<number>;
        mintPreviewImageUrls: Array<string> | null;
        mintPreviewMediaUrls: Array<string> | null;
        logoUrl: string | null;
      } | null;
      generativeDetails: {
        __typename: "GenerativeDetails";
        logoUrl: string | null;
        generativeCodeUri: string;
        allowedHashes: Array<string> | null;
        mirroredBaseUri: string | null;
        captureSettings: {
          __typename: "GenerativeCaptureSettings";
          trigger: Types.CapturePreviewTriggerType;
          delay: number | null;
          selector: string | null;
          viewPort: {
            __typename: "GenerativeCaptureViewPortSettings";
            height: number;
            width: number;
          } | null;
        };
      } | null;
      seriesImages: {
        __typename: "SeriesImages";
        urls: Array<string>;
        coverImageUrl: string;
      } | null;
      editions: Array<{
        __typename: "EditionToken";
        name: string;
        description: string;
        image: string;
        size: number;
        onChainImage: string;
        nonTransferable: boolean | null;
        attributes: Array<{
          __typename: "TokenMetadataAttribute";
          trait_type: string;
          value: string;
        }> | null;
      }> | null;
      tokens: Array<{
        __typename: "GeneralToken";
        animation_url: string | null;
        image: string;
        name: string;
        description: string;
        id: string;
        nonTransferable: boolean | null;
        royalty: {
          __typename: "V1Royalty";
          royaltyPercentageString: string | null;
          royaltyRecipient: string | null;
        } | null;
      }> | null;
      importData: {
        __typename: "ImportData";
        description: string | null;
        media: string | null;
        standard: string | null;
        royalty: {
          __typename: "V1Royalty";
          royaltyRecipient: string | null;
          royaltyPercentageString: string | null;
        } | null;
      } | null;
      contract: { __typename: "Contract2"; address: string | null } | null;
    }>;
    tokens: Array<{
      __typename: "ImportedToken";
      id: string;
      type: Types.ImportedTokenType | null;
      name: string;
      symbol: string | null;
      address: string;
      tokenId: string | null;
      chainId: number;
      contractUri: string | null;
      importData: {
        __typename: "ImportData";
        description: string | null;
        media: string | null;
        standard: string | null;
      } | null;
    }>;
  };
};

export type ImportedTokensPaginatedQueryVariables = Types.Exact<{
  first: Types.Maybe<Types.Scalars["Float"]>;
  cursor: Types.Maybe<Types.Scalars["String"]>;
  onlySingleTokens: Types.Maybe<Types.Scalars["Boolean"]>;
  onlyCollections: Types.Maybe<Types.Scalars["Boolean"]>;
}>;

export type ImportedTokensPaginatedQuery = {
  importedTokensPaginated: {
    __typename: "ImportedTokensPaginated";
    importedTokens: Array<{
      __typename: "ImportedToken";
      id: string;
      type: Types.ImportedTokenType | null;
      name: string;
      symbol: string | null;
      address: string;
      tokenId: string | null;
      chainId: number;
      contractUri: string | null;
      importData: {
        __typename: "ImportData";
        description: string | null;
        media: string | null;
        standard: string | null;
      } | null;
    }>;
    pageInfo: {
      __typename: "CursorPaginatedInfo";
      endCursor: string | null;
      hasNextPage: boolean;
    };
  };
};

export type GetCollectionByUserQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetCollectionByUserQuery = {
  getCollectionByUser: Array<{
    __typename: "Collection";
    id: string;
    name: string;
    type: Types.CollectionContractType;
    collectionType: Types._CollectionType;
    chainId: number;
    contractId: string;
    status: Types.CollectionStatus;
    createdAt: string;
    baseUri: string | null;
    standard: Types.NftContractStandard | null;
    usingOpenseaBlocklist: boolean | null;
    mintVectors: Array<{
      __typename: "MintVector";
      id: string | null;
      collectionId: string | null;
      start: string;
      end: string | null;
      paused: boolean | null;
      currency: string;
      maxPerTxn: number;
      maxPerUser: number;
      maxPerVector: number;
      price: string;
      priceType: Types.PriceType | null;
      stats: {
        __typename: "MintVectorStats";
        total: number;
        sold: number;
        status: Types.MintVectorStatus;
      } | null;
    }>;
    auctions: Array<{
      __typename: "Auction";
      id: string | null;
      collectionId: string;
      createdAt: string;
      start: string;
      end: string;
      paused: boolean | null;
      stats: {
        __typename: "AuctionStats";
        currentBid: number;
        highestBidder: string;
        status: Types.AuctionStatus;
        totalBids: number;
      } | null;
    }>;
    seriesDetails: {
      __typename: "SeriesDetails";
      coverImage: number;
      mintPreviewImages: Array<number>;
      mintPreviewImageUrls: Array<string> | null;
      mintPreviewMediaUrls: Array<string> | null;
      logoUrl: string | null;
    } | null;
    generativeDetails: {
      __typename: "GenerativeDetails";
      logoUrl: string | null;
      generativeCodeUri: string;
      allowedHashes: Array<string> | null;
      mirroredBaseUri: string | null;
      captureSettings: {
        __typename: "GenerativeCaptureSettings";
        trigger: Types.CapturePreviewTriggerType;
        delay: number | null;
        selector: string | null;
        viewPort: {
          __typename: "GenerativeCaptureViewPortSettings";
          height: number;
          width: number;
        } | null;
      };
    } | null;
    seriesImages: {
      __typename: "SeriesImages";
      urls: Array<string>;
      coverImageUrl: string;
    } | null;
    editions: Array<{
      __typename: "EditionToken";
      name: string;
      description: string;
      image: string;
      size: number;
      onChainImage: string;
      nonTransferable: boolean | null;
      attributes: Array<{
        __typename: "TokenMetadataAttribute";
        trait_type: string;
        value: string;
      }> | null;
    }> | null;
    tokens: Array<{
      __typename: "GeneralToken";
      animation_url: string | null;
      image: string;
      name: string;
      description: string;
      id: string;
      nonTransferable: boolean | null;
      royalty: {
        __typename: "V1Royalty";
        royaltyPercentageString: string | null;
        royaltyRecipient: string | null;
      } | null;
    }> | null;
    importData: {
      __typename: "ImportData";
      description: string | null;
      media: string | null;
      standard: string | null;
      royalty: {
        __typename: "V1Royalty";
        royaltyRecipient: string | null;
        royaltyPercentageString: string | null;
      } | null;
    } | null;
    contract: { __typename: "Contract2"; address: string | null } | null;
  }>;
};

export type GetCollectionByUserPaginatedQueryVariables = Types.Exact<{
  first: Types.Maybe<Types.Scalars["Float"]>;
  cursor: Types.Maybe<Types.Scalars["String"]>;
  search: Types.Maybe<Types.Scalars["String"]>;
  sortBy: Types.Maybe<Types.CollectionSortableField>;
  sortDirection: Types.Maybe<Types.CollectionSortDirection>;
  contractId: Types.Maybe<Types.Scalars["String"]>;
}>;

export type GetCollectionByUserPaginatedQuery = {
  getCollectionByUserPaginated: {
    __typename: "CollectionsPaginated";
    collections: Array<{
      __typename: "Collection";
      id: string;
      name: string;
      type: Types.CollectionContractType;
      collectionType: Types._CollectionType;
      chainId: number;
      contractId: string;
      status: Types.CollectionStatus;
      createdAt: string;
      baseUri: string | null;
      standard: Types.NftContractStandard | null;
      usingOpenseaBlocklist: boolean | null;
      mintVectors: Array<{
        __typename: "MintVector";
        id: string | null;
        collectionId: string | null;
        start: string;
        end: string | null;
        paused: boolean | null;
        currency: string;
        maxPerTxn: number;
        maxPerUser: number;
        maxPerVector: number;
        price: string;
        priceType: Types.PriceType | null;
        stats: {
          __typename: "MintVectorStats";
          total: number;
          sold: number;
          status: Types.MintVectorStatus;
        } | null;
      }>;
      auctions: Array<{
        __typename: "Auction";
        id: string | null;
        collectionId: string;
        createdAt: string;
        start: string;
        end: string;
        paused: boolean | null;
        stats: {
          __typename: "AuctionStats";
          currentBid: number;
          highestBidder: string;
          status: Types.AuctionStatus;
          totalBids: number;
        } | null;
      }>;
      seriesDetails: {
        __typename: "SeriesDetails";
        coverImage: number;
        mintPreviewImages: Array<number>;
        mintPreviewImageUrls: Array<string> | null;
        mintPreviewMediaUrls: Array<string> | null;
        logoUrl: string | null;
      } | null;
      generativeDetails: {
        __typename: "GenerativeDetails";
        logoUrl: string | null;
        generativeCodeUri: string;
        allowedHashes: Array<string> | null;
        mirroredBaseUri: string | null;
        captureSettings: {
          __typename: "GenerativeCaptureSettings";
          trigger: Types.CapturePreviewTriggerType;
          delay: number | null;
          selector: string | null;
          viewPort: {
            __typename: "GenerativeCaptureViewPortSettings";
            height: number;
            width: number;
          } | null;
        };
      } | null;
      seriesImages: {
        __typename: "SeriesImages";
        urls: Array<string>;
        coverImageUrl: string;
      } | null;
      editions: Array<{
        __typename: "EditionToken";
        name: string;
        description: string;
        image: string;
        size: number;
        onChainImage: string;
        nonTransferable: boolean | null;
        attributes: Array<{
          __typename: "TokenMetadataAttribute";
          trait_type: string;
          value: string;
        }> | null;
      }> | null;
      tokens: Array<{
        __typename: "GeneralToken";
        animation_url: string | null;
        image: string;
        name: string;
        description: string;
        id: string;
        nonTransferable: boolean | null;
        royalty: {
          __typename: "V1Royalty";
          royaltyPercentageString: string | null;
          royaltyRecipient: string | null;
        } | null;
      }> | null;
      importData: {
        __typename: "ImportData";
        description: string | null;
        media: string | null;
        standard: string | null;
        royalty: {
          __typename: "V1Royalty";
          royaltyRecipient: string | null;
          royaltyPercentageString: string | null;
        } | null;
      } | null;
      contract: { __typename: "Contract2"; address: string | null } | null;
    }>;
    pageInfo: {
      __typename: "CursorPaginatedInfo";
      endCursor: string | null;
      hasNextPage: boolean;
    };
  };
};

export type GetMergedCollectionByUserPaginatedQueryVariables = Types.Exact<{
  page: Types.Maybe<Types.Scalars["Float"]>;
  limit: Types.Maybe<Types.Scalars["Float"]>;
  sortBy: Types.Maybe<Types.CollectionSortableField>;
  sortDirection: Types.Maybe<Types.CollectionSortDirection>;
  filters: Types.Maybe<Types.CollectionFilters>;
}>;

export type GetMergedCollectionByUserPaginatedQuery = {
  getMergedCollectionByUserPaginated: {
    __typename: "MergedCollectionsPaginated";
    collections: Array<
      | {
          __typename: "MergedCollection";
          id: string;
          name: string;
          type: Types.CollectionContractType;
          collectionType: Types._CollectionType;
          chainId: number;
          contractId: string;
          status: Types.CollectionStatus;
          createdAt: string;
          baseUri: string | null;
          usingOpenseaBlocklist: boolean | null;
          isDraft: boolean;
          archivedAt: string | null;
          standard: Types.NftContractStandard | null;
          seriesDetails: {
            __typename: "SeriesDetails";
            coverImage: number;
            mintPreviewImages: Array<number>;
            mintPreviewImageUrls: Array<string> | null;
            mintPreviewMediaUrls: Array<string> | null;
            logoUrl: string | null;
          } | null;
          generativeDetails: {
            __typename: "GenerativeDetails";
            logoUrl: string | null;
            generativeCodeUri: string;
            allowedHashes: Array<string> | null;
            mirroredBaseUri: string | null;
            captureSettings: {
              __typename: "GenerativeCaptureSettings";
              trigger: Types.CapturePreviewTriggerType;
              delay: number | null;
              selector: string | null;
              viewPort: {
                __typename: "GenerativeCaptureViewPortSettings";
                height: number;
                width: number;
              } | null;
            };
          } | null;
          seriesImages: {
            __typename: "SeriesImages";
            urls: Array<string>;
            coverImageUrl: string;
          } | null;
          editions: Array<{
            __typename: "EditionToken";
            name: string;
            description: string;
            image: string;
            size: number;
            onChainImage: string;
            nonTransferable: boolean | null;
            attributes: Array<{
              __typename: "TokenMetadataAttribute";
              trait_type: string;
              value: string;
            }> | null;
          }> | null;
          tokens: Array<{
            __typename: "GeneralToken";
            animation_url: string | null;
            image: string;
            name: string;
            description: string;
            id: string;
            nonTransferable: boolean | null;
            royalty: {
              __typename: "V1Royalty";
              royaltyPercentageString: string | null;
              royaltyRecipient: string | null;
            } | null;
          }> | null;
          importData: {
            __typename: "ImportData";
            description: string | null;
            media: string | null;
            standard: string | null;
            royalty: {
              __typename: "V1Royalty";
              royaltyRecipient: string | null;
              royaltyPercentageString: string | null;
            } | null;
          } | null;
          contract: {
            __typename: "Contract2";
            address: string | null;
            contractType: Types.ContractEntityType;
          } | null;
          mintVectors: Array<{
            __typename: "MintVector";
            id: string | null;
            collectionId: string | null;
            start: string;
            end: string | null;
            paused: boolean | null;
            currency: string;
            maxPerTxn: number;
            maxPerUser: number;
            maxPerVector: number;
            price: string;
            priceType: Types.PriceType | null;
            stats: {
              __typename: "MintVectorStats";
              total: number;
              sold: number;
              status: Types.MintVectorStatus;
            } | null;
          }>;
          auctions: Array<{
            __typename: "Auction";
            id: string | null;
            collectionId: string;
            createdAt: string;
            start: string;
            end: string;
            paused: boolean | null;
            stats: {
              __typename: "AuctionStats";
              currentBid: number;
              highestBidder: string;
              status: Types.AuctionStatus;
              totalBids: number;
            } | null;
          }>;
        }
      | {
          __typename: "MergedDraft";
          collectionType: Types._CollectionType;
          createdAt: string;
          id: string;
          isDraft: boolean;
          archivedAt: string | null;
          collectionDraft: {
            __typename: "CollectionDetailsDraft";
            name: string | null;
            generativeDetails: {
              __typename: "GenerativeDetailsDraft";
              allowedHashes: Array<string> | null;
              captureSettings: {
                __typename: "GenerativeCaptureSettings";
                trigger: Types.CapturePreviewTriggerType;
                delay: number | null;
                selector: string | null;
                viewPort: {
                  __typename: "GenerativeCaptureViewPortSettings";
                  height: number;
                  width: number;
                } | null;
              } | null;
            } | null;
            seriesDetails: {
              __typename: "SeriesDetailsDraft";
              coverImage: Array<number> | null;
              mintPreviewImages: Array<number> | null;
              mintPreviewImageUrls: Array<string> | null;
              mintPreviewMediaUrls: Array<string> | null;
            } | null;
          } | null;
          contractDraft: {
            __typename: "ContractDraft";
            chainId: number | null;
            symbol: string | null;
            usingOpenseaBlocklist: boolean | null;
            collectionLogoImage: string | null;
            contractStandard: Types.NftContractStandard | null;
          } | null;
          metadata: {
            __typename: "CollectionMetadata";
            mediaUrl: string | null;
            seriesDetails: {
              __typename: "SeriesDetailsDraft";
              coverImage: Array<number> | null;
              mintPreviewImageUrls: Array<string> | null;
              mintPreviewImages: Array<number> | null;
              mintPreviewMediaUrls: Array<string> | null;
            } | null;
          } | null;
          distributionDraft: {
            __typename: "DistributionDraft";
            saleDateTo: string | null;
            saleDateFrom: string | null;
            price: string | null;
            currency: string | null;
            priceType: Types.PriceType | null;
            type: Types.TokenDistributionType;
          } | null;
        }
    >;
    pageInfo: {
      __typename: "PagePaginatedInfo";
      page: number;
      totalCount: number;
    };
  };
};

export type GetCollectionQueryVariables = Types.Exact<{
  collectionId: Types.Scalars["String"];
}>;

export type GetCollectionQuery = {
  getCollection: {
    __typename: "Collection";
    id: string;
    name: string;
    type: Types.CollectionContractType;
    collectionType: Types._CollectionType;
    chainId: number;
    contractId: string;
    status: Types.CollectionStatus;
    createdAt: string;
    baseUri: string | null;
    standard: Types.NftContractStandard | null;
    usingOpenseaBlocklist: boolean | null;
    seriesDetails: {
      __typename: "SeriesDetails";
      coverImage: number;
      mintPreviewImages: Array<number>;
      mintPreviewImageUrls: Array<string> | null;
      mintPreviewMediaUrls: Array<string> | null;
      logoUrl: string | null;
    } | null;
    generativeDetails: {
      __typename: "GenerativeDetails";
      logoUrl: string | null;
      generativeCodeUri: string;
      allowedHashes: Array<string> | null;
      mirroredBaseUri: string | null;
      captureSettings: {
        __typename: "GenerativeCaptureSettings";
        trigger: Types.CapturePreviewTriggerType;
        delay: number | null;
        selector: string | null;
        viewPort: {
          __typename: "GenerativeCaptureViewPortSettings";
          height: number;
          width: number;
        } | null;
      };
    } | null;
    seriesImages: {
      __typename: "SeriesImages";
      urls: Array<string>;
      coverImageUrl: string;
    } | null;
    editions: Array<{
      __typename: "EditionToken";
      name: string;
      description: string;
      image: string;
      size: number;
      onChainImage: string;
      nonTransferable: boolean | null;
      attributes: Array<{
        __typename: "TokenMetadataAttribute";
        trait_type: string;
        value: string;
      }> | null;
    }> | null;
    tokens: Array<{
      __typename: "GeneralToken";
      animation_url: string | null;
      image: string;
      name: string;
      description: string;
      id: string;
      nonTransferable: boolean | null;
      royalty: {
        __typename: "V1Royalty";
        royaltyPercentageString: string | null;
        royaltyRecipient: string | null;
      } | null;
    }> | null;
    importData: {
      __typename: "ImportData";
      description: string | null;
      media: string | null;
      standard: string | null;
      royalty: {
        __typename: "V1Royalty";
        royaltyRecipient: string | null;
        royaltyPercentageString: string | null;
      } | null;
    } | null;
    contract: { __typename: "Contract2"; address: string | null } | null;
  };
};

export type CreateMintVectorMutationVariables = Types.Exact<{
  data: Types.CreateMintVectorInput;
}>;

export type CreateMintVectorMutation = {
  createMintVector: {
    __typename: "MintVector";
    id: string | null;
    collectionId: string | null;
    start: string;
    end: string | null;
    price: string;
    currency: string;
    maxPerTxn: number;
    maxPerUser: number;
    maxPerVector: number;
    gateId: string | null;
    paymentRecipient: string;
  };
};

export type GetMintVectorsByCollectionQueryVariables = Types.Exact<{
  collectionId: Types.Scalars["String"];
}>;

export type GetMintVectorsByCollectionQuery = {
  getMintVectorsByCollection: Array<{
    __typename: "MintVector";
    id: string | null;
    collectionId: string | null;
    start: string;
    end: string | null;
    price: string;
    currency: string;
    maxPerTxn: number;
    maxPerUser: number;
    maxPerVector: number;
    gateId: string | null;
    paymentRecipient: string;
  }>;
};

export type CreateTokenMutationVariables = Types.Exact<{
  data: Types.CreateTokenInput;
}>;

export type CreateTokenMutation = {
  createToken: {
    __typename: "CreateTokenOutput";
    collection: {
      __typename: "Collection";
      id: string;
      name: string;
      type: Types.CollectionContractType;
      collectionType: Types._CollectionType;
      chainId: number;
      contractId: string;
      status: Types.CollectionStatus;
      createdAt: string;
      baseUri: string | null;
      standard: Types.NftContractStandard | null;
      usingOpenseaBlocklist: boolean | null;
      seriesDetails: {
        __typename: "SeriesDetails";
        coverImage: number;
        mintPreviewImages: Array<number>;
        mintPreviewImageUrls: Array<string> | null;
        mintPreviewMediaUrls: Array<string> | null;
        logoUrl: string | null;
      } | null;
      generativeDetails: {
        __typename: "GenerativeDetails";
        logoUrl: string | null;
        generativeCodeUri: string;
        allowedHashes: Array<string> | null;
        mirroredBaseUri: string | null;
        captureSettings: {
          __typename: "GenerativeCaptureSettings";
          trigger: Types.CapturePreviewTriggerType;
          delay: number | null;
          selector: string | null;
          viewPort: {
            __typename: "GenerativeCaptureViewPortSettings";
            height: number;
            width: number;
          } | null;
        };
      } | null;
      seriesImages: {
        __typename: "SeriesImages";
        urls: Array<string>;
        coverImageUrl: string;
      } | null;
      editions: Array<{
        __typename: "EditionToken";
        name: string;
        description: string;
        image: string;
        size: number;
        onChainImage: string;
        nonTransferable: boolean | null;
        attributes: Array<{
          __typename: "TokenMetadataAttribute";
          trait_type: string;
          value: string;
        }> | null;
      }> | null;
      tokens: Array<{
        __typename: "GeneralToken";
        animation_url: string | null;
        image: string;
        name: string;
        description: string;
        id: string;
        nonTransferable: boolean | null;
        royalty: {
          __typename: "V1Royalty";
          royaltyPercentageString: string | null;
          royaltyRecipient: string | null;
        } | null;
      }> | null;
      importData: {
        __typename: "ImportData";
        description: string | null;
        media: string | null;
        standard: string | null;
        royalty: {
          __typename: "V1Royalty";
          royaltyRecipient: string | null;
          royaltyPercentageString: string | null;
        } | null;
      } | null;
      contract: { __typename: "Contract2"; address: string | null } | null;
    };
    contract: {
      __typename: "TransactionArgs";
      address: string | null;
      args: string;
      chainId: number;
      method: string | null;
      bytecode: string | null;
    };
  };
};

export type CreateImportedTokenMutationVariables = Types.Exact<{
  data: Types.CreateImportedTokenInput;
}>;

export type CreateImportedTokenMutation = { createImportedToken: string };

export const CollectionFieldsFragmentDoc = gql`
  fragment CollectionFields on Collection {
    id
    name
    type
    collectionType
    chainId
    contractId
    status
    createdAt
    baseUri
    seriesDetails {
      coverImage
      mintPreviewImages
      mintPreviewImageUrls
      mintPreviewMediaUrls
      logoUrl
    }
    generativeDetails {
      logoUrl
      generativeCodeUri
      allowedHashes
      mirroredBaseUri
      captureSettings {
        trigger
        delay
        selector
        viewPort {
          height
          width
        }
      }
    }
    seriesImages {
      urls
      coverImageUrl
    }
    editions {
      name
      description
      image
      size
      onChainImage
      nonTransferable
      attributes {
        trait_type
        value
      }
    }
    standard
    tokens {
      animation_url
      image
      name
      description
      id
      nonTransferable
      royalty {
        royaltyPercentageString
        royaltyRecipient
      }
    }
    importData {
      description
      media
      royalty {
        royaltyRecipient
        royaltyPercentageString
      }
      standard
    }
    contract {
      address
    }
    usingOpenseaBlocklist
  }
`;
export const MintVectorFieldsFragmentDoc = gql`
  fragment MintVectorFields on MintVector {
    id
    collectionId
    start
    end
    price
    currency
    maxPerTxn
    maxPerUser
    maxPerVector
    gateId
    paymentRecipient
  }
`;
export const ImportTokenFieldsFragmentDoc = gql`
  fragment ImportTokenFields on ImportedToken {
    id
    type
    name
    symbol
    address
    tokenId
    chainId
    contractUri
    importData {
      description
      media
      standard
    }
  }
`;
export const MintVectorByCollectionFieldsFragmentDoc = gql`
  fragment MintVectorByCollectionFields on MintVector {
    id
    collectionId
    start
    end
    paused
    stats {
      total
      sold
      status
    }
    currency
    maxPerTxn
    maxPerUser
    maxPerVector
    price
    priceType
  }
`;
export const AuctionByCollectionFieldsFragmentDoc = gql`
  fragment AuctionByCollectionFields on Auction {
    id
    collectionId
    createdAt
    start
    end
    paused
    stats {
      currentBid
      highestBidder
      status
      totalBids
    }
  }
`;
export const GetBlockchainEntitiesByUserDocument = gql`
  query GetBlockchainEntitiesByUser {
    getBlockchainEntitiesByUser {
      collections {
        ...CollectionFields
        mintVectors {
          ...MintVectorByCollectionFields
        }
        auctions {
          ...AuctionByCollectionFields
        }
        openSeaCollectionUrl
      }
      tokens {
        ...ImportTokenFields
      }
    }
  }
  ${CollectionFieldsFragmentDoc}
  ${MintVectorByCollectionFieldsFragmentDoc}
  ${AuctionByCollectionFieldsFragmentDoc}
  ${ImportTokenFieldsFragmentDoc}
`;

/**
 * __useGetBlockchainEntitiesByUserQuery__
 *
 * To run a query within a React component, call `useGetBlockchainEntitiesByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockchainEntitiesByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockchainEntitiesByUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBlockchainEntitiesByUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetBlockchainEntitiesByUserQuery,
    GetBlockchainEntitiesByUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetBlockchainEntitiesByUserQuery,
    GetBlockchainEntitiesByUserQueryVariables
  >(GetBlockchainEntitiesByUserDocument, options);
}
export function useGetBlockchainEntitiesByUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBlockchainEntitiesByUserQuery,
    GetBlockchainEntitiesByUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetBlockchainEntitiesByUserQuery,
    GetBlockchainEntitiesByUserQueryVariables
  >(GetBlockchainEntitiesByUserDocument, options);
}
export type GetBlockchainEntitiesByUserQueryHookResult = ReturnType<
  typeof useGetBlockchainEntitiesByUserQuery
>;
export type GetBlockchainEntitiesByUserLazyQueryHookResult = ReturnType<
  typeof useGetBlockchainEntitiesByUserLazyQuery
>;
export type GetBlockchainEntitiesByUserQueryResult = Apollo.QueryResult<
  GetBlockchainEntitiesByUserQuery,
  GetBlockchainEntitiesByUserQueryVariables
>;
export const ImportedTokensPaginatedDocument = gql`
  query ImportedTokensPaginated(
    $first: Float
    $cursor: String
    $onlySingleTokens: Boolean
    $onlyCollections: Boolean
  ) {
    importedTokensPaginated(
      first: $first
      after: $cursor
      onlySingleTokens: $onlySingleTokens
      onlyCollections: $onlyCollections
    ) {
      importedTokens {
        ...ImportTokenFields
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  ${ImportTokenFieldsFragmentDoc}
`;

/**
 * __useImportedTokensPaginatedQuery__
 *
 * To run a query within a React component, call `useImportedTokensPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportedTokensPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportedTokensPaginatedQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      onlySingleTokens: // value for 'onlySingleTokens'
 *      onlyCollections: // value for 'onlyCollections'
 *   },
 * });
 */
export function useImportedTokensPaginatedQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ImportedTokensPaginatedQuery,
    ImportedTokensPaginatedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ImportedTokensPaginatedQuery,
    ImportedTokensPaginatedQueryVariables
  >(ImportedTokensPaginatedDocument, options);
}
export function useImportedTokensPaginatedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ImportedTokensPaginatedQuery,
    ImportedTokensPaginatedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ImportedTokensPaginatedQuery,
    ImportedTokensPaginatedQueryVariables
  >(ImportedTokensPaginatedDocument, options);
}
export type ImportedTokensPaginatedQueryHookResult = ReturnType<
  typeof useImportedTokensPaginatedQuery
>;
export type ImportedTokensPaginatedLazyQueryHookResult = ReturnType<
  typeof useImportedTokensPaginatedLazyQuery
>;
export type ImportedTokensPaginatedQueryResult = Apollo.QueryResult<
  ImportedTokensPaginatedQuery,
  ImportedTokensPaginatedQueryVariables
>;
export const GetCollectionByUserDocument = gql`
  query GetCollectionByUser {
    getCollectionByUser {
      ...CollectionFields
      mintVectors {
        ...MintVectorByCollectionFields
      }
      auctions {
        ...AuctionByCollectionFields
      }
    }
  }
  ${CollectionFieldsFragmentDoc}
  ${MintVectorByCollectionFieldsFragmentDoc}
  ${AuctionByCollectionFieldsFragmentDoc}
`;

/**
 * __useGetCollectionByUserQuery__
 *
 * To run a query within a React component, call `useGetCollectionByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionByUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCollectionByUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCollectionByUserQuery,
    GetCollectionByUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCollectionByUserQuery,
    GetCollectionByUserQueryVariables
  >(GetCollectionByUserDocument, options);
}
export function useGetCollectionByUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCollectionByUserQuery,
    GetCollectionByUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCollectionByUserQuery,
    GetCollectionByUserQueryVariables
  >(GetCollectionByUserDocument, options);
}
export type GetCollectionByUserQueryHookResult = ReturnType<
  typeof useGetCollectionByUserQuery
>;
export type GetCollectionByUserLazyQueryHookResult = ReturnType<
  typeof useGetCollectionByUserLazyQuery
>;
export type GetCollectionByUserQueryResult = Apollo.QueryResult<
  GetCollectionByUserQuery,
  GetCollectionByUserQueryVariables
>;
export const GetCollectionByUserPaginatedDocument = gql`
  query GetCollectionByUserPaginated(
    $first: Float
    $cursor: String
    $search: String
    $sortBy: CollectionSortableField
    $sortDirection: CollectionSortDirection
    $contractId: String
  ) {
    getCollectionByUserPaginated(
      first: $first
      after: $cursor
      search: $search
      sortBy: $sortBy
      sortDirection: $sortDirection
      contractId: $contractId
    ) {
      collections {
        ...CollectionFields
        mintVectors {
          ...MintVectorByCollectionFields
        }
        auctions {
          ...AuctionByCollectionFields
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  ${CollectionFieldsFragmentDoc}
  ${MintVectorByCollectionFieldsFragmentDoc}
  ${AuctionByCollectionFieldsFragmentDoc}
`;

/**
 * __useGetCollectionByUserPaginatedQuery__
 *
 * To run a query within a React component, call `useGetCollectionByUserPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionByUserPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionByUserPaginatedQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      search: // value for 'search'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useGetCollectionByUserPaginatedQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCollectionByUserPaginatedQuery,
    GetCollectionByUserPaginatedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCollectionByUserPaginatedQuery,
    GetCollectionByUserPaginatedQueryVariables
  >(GetCollectionByUserPaginatedDocument, options);
}
export function useGetCollectionByUserPaginatedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCollectionByUserPaginatedQuery,
    GetCollectionByUserPaginatedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCollectionByUserPaginatedQuery,
    GetCollectionByUserPaginatedQueryVariables
  >(GetCollectionByUserPaginatedDocument, options);
}
export type GetCollectionByUserPaginatedQueryHookResult = ReturnType<
  typeof useGetCollectionByUserPaginatedQuery
>;
export type GetCollectionByUserPaginatedLazyQueryHookResult = ReturnType<
  typeof useGetCollectionByUserPaginatedLazyQuery
>;
export type GetCollectionByUserPaginatedQueryResult = Apollo.QueryResult<
  GetCollectionByUserPaginatedQuery,
  GetCollectionByUserPaginatedQueryVariables
>;
export const GetMergedCollectionByUserPaginatedDocument = gql`
  query GetMergedCollectionByUserPaginated(
    $page: Float
    $limit: Float
    $sortBy: CollectionSortableField
    $sortDirection: CollectionSortDirection
    $filters: CollectionFilters
  ) {
    getMergedCollectionByUserPaginated(
      page: $page
      limit: $limit
      sortBy: $sortBy
      sortDirection: $sortDirection
      filters: $filters
    ) {
      collections {
        ... on MergedCollection {
          id
          name
          type
          collectionType
          chainId
          contractId
          status
          createdAt
          baseUri
          seriesDetails {
            coverImage
            mintPreviewImages
            mintPreviewImageUrls
            mintPreviewMediaUrls
            logoUrl
          }
          generativeDetails {
            logoUrl
            generativeCodeUri
            allowedHashes
            mirroredBaseUri
            captureSettings {
              trigger
              delay
              selector
              viewPort {
                height
                width
              }
            }
          }
          seriesImages {
            urls
            coverImageUrl
          }
          editions {
            name
            description
            image
            size
            onChainImage
            nonTransferable
            attributes {
              trait_type
              value
            }
          }
          tokens {
            animation_url
            image
            name
            description
            id
            nonTransferable
            royalty {
              royaltyPercentageString
              royaltyRecipient
            }
          }
          importData {
            description
            media
            royalty {
              royaltyRecipient
              royaltyPercentageString
            }
            standard
          }
          contract {
            address
            contractType
          }
          usingOpenseaBlocklist
          isDraft
          archivedAt
          standard
          mintVectors {
            ...MintVectorByCollectionFields
          }
          auctions {
            ...AuctionByCollectionFields
          }
        }
        ... on MergedDraft {
          collectionType
          createdAt
          id
          isDraft
          archivedAt
          collectionDraft {
            name
            generativeDetails {
              allowedHashes
              captureSettings {
                trigger
                delay
                selector
                viewPort {
                  height
                  width
                }
              }
            }
            seriesDetails {
              coverImage
              mintPreviewImages
              mintPreviewImageUrls
              mintPreviewMediaUrls
            }
          }
          contractDraft {
            chainId
            symbol
            usingOpenseaBlocklist
            collectionLogoImage
            contractStandard
          }
          metadata {
            mediaUrl
            seriesDetails {
              coverImage
              mintPreviewImageUrls
              mintPreviewImages
              mintPreviewMediaUrls
            }
          }
          distributionDraft {
            saleDateTo
            saleDateFrom
            price
            currency
            priceType
            type
          }
        }
      }
      pageInfo {
        page
        totalCount
      }
    }
  }
  ${MintVectorByCollectionFieldsFragmentDoc}
  ${AuctionByCollectionFieldsFragmentDoc}
`;

/**
 * __useGetMergedCollectionByUserPaginatedQuery__
 *
 * To run a query within a React component, call `useGetMergedCollectionByUserPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMergedCollectionByUserPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMergedCollectionByUserPaginatedQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetMergedCollectionByUserPaginatedQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMergedCollectionByUserPaginatedQuery,
    GetMergedCollectionByUserPaginatedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMergedCollectionByUserPaginatedQuery,
    GetMergedCollectionByUserPaginatedQueryVariables
  >(GetMergedCollectionByUserPaginatedDocument, options);
}
export function useGetMergedCollectionByUserPaginatedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMergedCollectionByUserPaginatedQuery,
    GetMergedCollectionByUserPaginatedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMergedCollectionByUserPaginatedQuery,
    GetMergedCollectionByUserPaginatedQueryVariables
  >(GetMergedCollectionByUserPaginatedDocument, options);
}
export type GetMergedCollectionByUserPaginatedQueryHookResult = ReturnType<
  typeof useGetMergedCollectionByUserPaginatedQuery
>;
export type GetMergedCollectionByUserPaginatedLazyQueryHookResult = ReturnType<
  typeof useGetMergedCollectionByUserPaginatedLazyQuery
>;
export type GetMergedCollectionByUserPaginatedQueryResult = Apollo.QueryResult<
  GetMergedCollectionByUserPaginatedQuery,
  GetMergedCollectionByUserPaginatedQueryVariables
>;
export const GetCollectionDocument = gql`
  query GetCollection($collectionId: String!) {
    getCollection(collectionId: $collectionId) {
      ...CollectionFields
    }
  }
  ${CollectionFieldsFragmentDoc}
`;

/**
 * __useGetCollectionQuery__
 *
 * To run a query within a React component, call `useGetCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetCollectionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCollectionQuery,
    GetCollectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCollectionQuery, GetCollectionQueryVariables>(
    GetCollectionDocument,
    options
  );
}
export function useGetCollectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCollectionQuery,
    GetCollectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCollectionQuery, GetCollectionQueryVariables>(
    GetCollectionDocument,
    options
  );
}
export type GetCollectionQueryHookResult = ReturnType<
  typeof useGetCollectionQuery
>;
export type GetCollectionLazyQueryHookResult = ReturnType<
  typeof useGetCollectionLazyQuery
>;
export type GetCollectionQueryResult = Apollo.QueryResult<
  GetCollectionQuery,
  GetCollectionQueryVariables
>;
export const CreateMintVectorDocument = gql`
  mutation CreateMintVector($data: CreateMintVectorInput!) {
    createMintVector(data: $data) {
      ...MintVectorFields
    }
  }
  ${MintVectorFieldsFragmentDoc}
`;
export type CreateMintVectorMutationFn = Apollo.MutationFunction<
  CreateMintVectorMutation,
  CreateMintVectorMutationVariables
>;

/**
 * __useCreateMintVectorMutation__
 *
 * To run a mutation, you first call `useCreateMintVectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMintVectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMintVectorMutation, { data, loading, error }] = useCreateMintVectorMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateMintVectorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMintVectorMutation,
    CreateMintVectorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMintVectorMutation,
    CreateMintVectorMutationVariables
  >(CreateMintVectorDocument, options);
}
export type CreateMintVectorMutationHookResult = ReturnType<
  typeof useCreateMintVectorMutation
>;
export type CreateMintVectorMutationResult =
  Apollo.MutationResult<CreateMintVectorMutation>;
export type CreateMintVectorMutationOptions = Apollo.BaseMutationOptions<
  CreateMintVectorMutation,
  CreateMintVectorMutationVariables
>;
export const GetMintVectorsByCollectionDocument = gql`
  query GetMintVectorsByCollection($collectionId: String!) {
    getMintVectorsByCollection(collectionId: $collectionId) {
      ...MintVectorFields
    }
  }
  ${MintVectorFieldsFragmentDoc}
`;

/**
 * __useGetMintVectorsByCollectionQuery__
 *
 * To run a query within a React component, call `useGetMintVectorsByCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMintVectorsByCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMintVectorsByCollectionQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetMintVectorsByCollectionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMintVectorsByCollectionQuery,
    GetMintVectorsByCollectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMintVectorsByCollectionQuery,
    GetMintVectorsByCollectionQueryVariables
  >(GetMintVectorsByCollectionDocument, options);
}
export function useGetMintVectorsByCollectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMintVectorsByCollectionQuery,
    GetMintVectorsByCollectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMintVectorsByCollectionQuery,
    GetMintVectorsByCollectionQueryVariables
  >(GetMintVectorsByCollectionDocument, options);
}
export type GetMintVectorsByCollectionQueryHookResult = ReturnType<
  typeof useGetMintVectorsByCollectionQuery
>;
export type GetMintVectorsByCollectionLazyQueryHookResult = ReturnType<
  typeof useGetMintVectorsByCollectionLazyQuery
>;
export type GetMintVectorsByCollectionQueryResult = Apollo.QueryResult<
  GetMintVectorsByCollectionQuery,
  GetMintVectorsByCollectionQueryVariables
>;
export const CreateTokenDocument = gql`
  mutation CreateToken($data: CreateTokenInput!) {
    createToken(data: $data) {
      collection {
        ...CollectionFields
      }
      contract {
        address
        args
        chainId
        method
        bytecode
      }
    }
  }
  ${CollectionFieldsFragmentDoc}
`;
export type CreateTokenMutationFn = Apollo.MutationFunction<
  CreateTokenMutation,
  CreateTokenMutationVariables
>;

/**
 * __useCreateTokenMutation__
 *
 * To run a mutation, you first call `useCreateTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTokenMutation, { data, loading, error }] = useCreateTokenMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTokenMutation,
    CreateTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTokenMutation, CreateTokenMutationVariables>(
    CreateTokenDocument,
    options
  );
}
export type CreateTokenMutationHookResult = ReturnType<
  typeof useCreateTokenMutation
>;
export type CreateTokenMutationResult =
  Apollo.MutationResult<CreateTokenMutation>;
export type CreateTokenMutationOptions = Apollo.BaseMutationOptions<
  CreateTokenMutation,
  CreateTokenMutationVariables
>;
export const CreateImportedTokenDocument = gql`
  mutation CreateImportedToken($data: CreateImportedTokenInput!) {
    createImportedToken(data: $data)
  }
`;
export type CreateImportedTokenMutationFn = Apollo.MutationFunction<
  CreateImportedTokenMutation,
  CreateImportedTokenMutationVariables
>;

/**
 * __useCreateImportedTokenMutation__
 *
 * To run a mutation, you first call `useCreateImportedTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImportedTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImportedTokenMutation, { data, loading, error }] = useCreateImportedTokenMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateImportedTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateImportedTokenMutation,
    CreateImportedTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateImportedTokenMutation,
    CreateImportedTokenMutationVariables
  >(CreateImportedTokenDocument, options);
}
export type CreateImportedTokenMutationHookResult = ReturnType<
  typeof useCreateImportedTokenMutation
>;
export type CreateImportedTokenMutationResult =
  Apollo.MutationResult<CreateImportedTokenMutation>;
export type CreateImportedTokenMutationOptions = Apollo.BaseMutationOptions<
  CreateImportedTokenMutation,
  CreateImportedTokenMutationVariables
>;
